import Authentication from '../features/authentication';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { useLocation } from 'react-router-dom';

// A page for displaying the Authentication feature.
// Should be routed to /login-page.

const LoginPage = ({ documentTitle }) => {

    useDocumentTitle(documentTitle);
    const location = useLocation();

    return <Authentication message={location.state?.message}/>;
};

export default LoginPage;